import autoComplete from "@tarekraafat/autocomplete.js";
import FilterChiclets from "./FilterChiclets";

export default class TickerFilter {
  constructor(input, manager, chicletContainer) {
    this.input = input;
    this.manager = manager;
    this.chiclets = new FilterChiclets(chicletContainer);

    if (!this.input || !chicletContainer) return;

    this.init();
  }

  init() {
    this.ac = new autoComplete({
      selector: () => this.input,
      placeHolder: "Search ticker...",
      data: {
        src: async (query) => {
          try {
            this.showLoading();
            const res = await fetch(
              `${window.foolArchiveFilters.tickerSearchEndpoint}?search=${encodeURIComponent(
                query
              )}&per_page=10&orderby=count&order=desc`
            );
            if (!res.ok) return [];
            return await res.json();
          } catch (err) {
            console.error("Ticker search failed:", err);
            return [];
          } finally {
            this.hideLoading();
          }
        },
        keys: ["name"],
      },
      resultsList: { noResults: true, maxResults: 10 },
      resultItem: {
        highlight: true,
        element: (item, data) => {
          item.innerHTML = data.match;
        },
      },
      debounce: 500,
      threshold: 2,
      events: {
        input: {
          selection: (event) => {
            const selection = event.detail.selection.value;
            this.addTicker(selection.slug, selection.name);
          },
        },
      },
    });

    this.setCurrentSelection();
  }

  setCurrentSelection() {
    const urlParams = new URLSearchParams(window.location.search);
    const current = urlParams.get("tickerFilter");
    const tickers = current ? current.split(",") : [];

    this.renderChiclets(tickers.map((slug) => ({ slug, label: slug })));
  }

  addTicker(slug) {
    const current = this.manager.getParam("tickerFilter")
      ? this.manager.getParam("tickerFilter").split(",")
      : [];

    if (!current.includes(slug)) {
      current.push(slug);
      this.manager.setParam("tickerFilter", current.join(","));
      this.renderChiclets(current.map((s) => ({ slug: s, label: s })));
    }

    this.input.value = "";
  }

  renderChiclets(items) {
    this.chiclets.render(items, (slug) => this.removeTicker(slug));
  }

  removeTicker(slug) {
    const current = this.manager.getParam("tickerFilter")
      ? this.manager.getParam("tickerFilter").split(",")
      : [];
    const updated = current.filter((t) => t !== slug);

    this.manager.setParam("tickerFilter", updated.join(","));
    this.renderChiclets(updated.map((s) => ({ slug: s, label: s })));
  }

  showLoading() {
    this.input.closest(".autoComplete_wrapper")?.classList.add("loading");
  }

  hideLoading() {
    this.input.closest(".autoComplete_wrapper")?.classList.remove("loading");
  }
}
